import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackYandexMetrikaPage } from '../utils/yandexMetrika';

const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    trackYandexMetrikaPage(`${pathname}${search}`);
  }, [pathname, search]);

  return null;
};

export default ScrollToTop;
